import { TPageType } from 'shared/types/features';

export type TFirstBlockContentValue = {
  imageClass: string;
  title: string;
  description: TFirstBlockDescription[][];
  needBigFont?: boolean;
};

export type TFirstBlockContent = {
  [key in TPageType]: TFirstBlockContentValue;
};

export type TContent = {
  [key in TPageType]: React.FC;
};

export type TFirstBlockDescription = TDescriptionTextType | TDescriptionLinkType | TDescriptionAnchorLinkType;

type TDescriptionLinkType = {
  text: string;
  type: EDescriptionType.Link;
  url: string;
};

type TDescriptionAnchorLinkType = {
  text: string;
  type: EDescriptionType.AnchorLink;
  url: string;
};

type TDescriptionTextType = {
  text: string;
  type: EDescriptionType.Text;
};

export enum EDescriptionType {
  Link = 'link',
  AnchorLink = 'anchorLink',
  Text = 'text',
}
